import { safeGetItem, safeSetItem } from 'Utils/safeLocalStorage';

const TRACKING_KEYS = ['gclid', 'wbraid', 'gbraid'];

function setTrackingIds() {
  const params = new URLSearchParams(window.location.search);

  for (const key of TRACKING_KEYS) {
    const value = params.get(key);

    if (!value) {
      continue;
    }

    if (safeGetItem(key) === value) {
      continue;
    }

    safeSetItem(key, value);
  }
}

setTrackingIds();
